interface ResultRef {
  current: HTMLDivElement | null
}

export interface ResultRefs {
  [key: string]: ResultRef
}

export enum SelectionType {
  Auto,
  Keyboard,
  Cursor,
}

export interface SelectedResult {
  id: string | undefined
  type: SelectionType
}
